import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";


export const getConmprobanteRetencion = async () => {
    const respuesta = PrivateInterceptor('Finanzas/Retencion/ComprobanteRetencion', 'GET')
    return respuesta
};

export const getComprobantesEnc = async (data) => {
    const respuesta = PrivateInterceptor('Finanzas/Retencion/ComprobanteRetencion/ListEncabezadoPorFecha', 'POST', data);
    return respuesta
}

export const getComprobantesDet = async (data) => {
    const respuesta = PrivateInterceptor('Finanzas/Retencion/ComprobanteRetencion/ListDetallesPorFecha', 'POST', data);
    return respuesta
}

export const cambiarEstado = (datos) => {
    const respuesta = PrivateInterceptor("Finanzas/Retencion/ComprobanteRetencion/cambiarEstado", "POST", {datos});
    return respuesta;
};

export const ObtenerNoRetencion = async () => {
    const respuesta = PrivateInterceptor('Finanzas/Retencion/ComprobanteRetencion/ObtenerNoRetencion', 'GET')
    return respuesta
};

export const getDetallesEncabezado = async(IdComprobanteRetencionEnc) =>{
    const result = await PrivateInterceptor(`Finanzas/Retencion/ComprobanteRetencion/${IdComprobanteRetencionEnc}`, 'GET');
    return result;
}

export const DetallesByConcepto = async(IdConceptoRetencion, IdVendor) =>{
    const result = await PrivateInterceptor(`Finanzas/Retencion/ComprobanteRetencion/DetallesByConcepto`, 'POST',{IdConceptoRetencion, IdVendor});
    return result;
}

// GUARDAR COMPROBANTE
export const GuardarComprobanteRetencion = async (data, data1) => {
    const respuesta = await PrivateInterceptor('Finanzas/Retencion/ComprobanteRetencion/GuardarComprobanteRetencion', 'POST', {Encabezado: data, Detalle: data1});
    return respuesta;
}

// GUARDAR COMPROBANTE
export const EditarComprobanteRetencion = async (data, data1) => {
    const respuesta = await PrivateInterceptor('Finanzas/Retencion/ComprobanteRetencion/EditarComprobanteRetencion', 'POST', {Encabezado: data, Detalle: data1});
    return respuesta;
}

// ELIMINAR DETALLE
export const EliminarDetalleRetencion = async (data1) => {
    const respuesta = await PrivateInterceptor('Finanzas/Retencion/ComprobanteRetencion/EliminarDetalleRetencion', 'POST', { Detalle: data1});
    return respuesta;
}

export const getEncabezadoById = async(IdComprobanteRetencionEnc) =>{
    const result = await PrivateInterceptor(`Finanzas/Retencion/ComprobanteRetencion/Encabezado/${IdComprobanteRetencionEnc}`, 'GET');
    return result;
}

export const AnularRet = async (data) => {
    const respuesta = await PrivateInterceptor('Finanzas/Retencion/ComprobanteRetencion/AnularRetencion', 'POST', { Encabezado: data});
    return respuesta;
}